import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  IconButton,
  Box,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { FormattedMessage } from 'react-intl'
import { uniqueId } from 'lodash'
import {
  setIsOpenImportedSubscribersResultDialog,
  useImportExternalSourceData,
} from 'app/store/importExternalSource'
import CheckCircleOutlineIcon from 'app/components/icons/CheckCircleOutlineIcon'
import { Routes } from 'app/services/routeService/routeService'
import themesConfig from 'app/fuse-configs/themesConfig'
import CircularProgressWithLabel from '../../LoadingProgress/CircularProgressWithLabel'

import useStyles from './styles'

const importedSubscribersResult = [
  {
    countKey: 'createdSubscribersCount',
    idLabel:
      'subscribers.importExternalSource.importedSubscribersResultDialog.text1',
  },
  {
    countKey: 'createdGroupCount',
    idLabel:
      'subscribers.importExternalSource.importedSubscribersResultDialog.text2',
  },
  {
    countKey: 'createdTagCount',
    idLabel:
      'subscribers.importExternalSource.importedSubscribersResultDialog.text3',
  },
]

const ImportedSubscribersResultDialog = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const {
    isOpenImportedSubscribersResultDialog,
    checkImportData,
    checkImportStatus,
  } = useImportExternalSourceData()
  const classes = useStyles()

  const onClose = () => {
    dispatch(setIsOpenImportedSubscribersResultDialog(false))
  }

  const goToGroups = () => {
    onClose()
    history.push(Routes.groups())
  }

  const goToSubscriberCRM = () => {
    onClose()
    history.push(Routes.subscribersV4())
  }

  return (
    <Dialog
      className={classes.dialogWrap}
      open={isOpenImportedSubscribersResultDialog}
    >
      <DialogTitle className={classes.dialogTitle}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          sx={{
            gap: 8,
            '& > svg': {
              width: 30,
              height: 30,
            },
          }}
        >
          <CheckCircleOutlineIcon classes="w-30" />
          <FormattedMessage id="subscribers.importExternalSource.importedSubscribersResultDialog.title" />
        </Box>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {checkImportStatus === 'loading' ? (
          <Box
            width={'100%'}
            height={'100%'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <CircularProgressWithLabel size={50} value={0} />
          </Box>
        ) : (
          importedSubscribersResult.map(({ countKey, idLabel }) => {
            const count = checkImportData[countKey] || 0
            return (
              <Box
                key={uniqueId()}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                flexWrap={'wrap'}
                p={'12px 12px 42px 12px'}
                minWidth={150}
                bgcolor={themesConfig.default.colors['primary-200']}
                sx={{ gap: 8 }}
                flex={1}
              >
                <Box
                  component={'p'}
                  color={themesConfig.default.colors.black}
                  fontWeight={700}
                  fontSize={20}
                >
                  {count}
                </Box>
                <Box
                  component={'p'}
                  color={themesConfig.default.colors.primary}
                  fontSize={16}
                  textAlign={'center'}
                >
                  <FormattedMessage id={idLabel} />
                </Box>
              </Box>
            )
          })
        )}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          variant="outlined"
          onClick={goToGroups}
          className={classes.actionbutton1}
        >
          <FormattedMessage id="subscribers.importExternalSource.importedSubscribersResultDialog.actionBtn.label" />
        </Button>
        <Button
          variant="contained"
          onClick={goToSubscriberCRM}
          className={classes.actionbutton2}
        >
          <FormattedMessage id="subscribers.import.dialogImportedSubscribers.actionBtn2.label" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ImportedSubscribersResultDialog
